import React, { useState, useEffect } from 'react';

const Portfolio = () => {
  const [hoveredProject, setHoveredProject] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showInfo, setShowInfo] = useState(false);
  // NEW: Track which filter is active (null means show all projects)
  const [activeFilter, setActiveFilter] = useState("All");

  const goHome = () => {
    setSelectedProject(null);
    setShowInfo(false);
    setHoveredProject(null);
    setActiveFilter("All");
  };

  useEffect(() => {
    const handlePopState = () => goHome();
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);



  // ============================================
  // PROJECTS DATA - Edit ALL your projects here in one place
  // ============================================
  // For each project, you can customize:
  // - x, y: Position of dot on screen (0-100)
  // - title: Project name
  // - image: Main project image
  // - description: Project description text
  // - image1, image2: Two additional images for the grid
  // - categories: Array of filter categories this project belongs to (NEW!)
  const projects = [
    { 
      id: 1, 
      title: "Democracy Works", 
      x: 35, 
      y: 45, 
      categories: ["Identity"],
      year: "2025-2026",
      role: "Designer, Art Director",
      deliverables: "Brand identity, rebrand materials",
      image: "/images/dw-main.png",
      tagline: "Rebuilding the visual language of civic infrastructure",
      description: "→ Intro\n [Democracy Works](https://www.democracy.works)is a civic tech nonprofit that helps Americans vote by partnering with election officials, major platforms, civic organizations, and companies to provide accurate data for voter access. I was tasked with working with contractors to help define our new identity and implement the organization’s marketing assets with the new brand.\n\n Web design by Haley, Ryan \nBrand design by Chris Atkins",
      research: "→ Challenge\n The challenge was combining all the tools under one website and creating a cohesive branding that would work across all the sub-brands. While each tool had a different audience, it was essential to unite them under one house name so users could trace back to the main organization behind the work: Democracy Works.",
      result: "→ Solution\n We created a reusable logomark that referenced the organization’s initials and assigned a brand color (DW Purple) with different hues that worked with a wide spectrum. This provided room for exploration when crafting marketing assets. For example, darker, more muted colors were used to hold weight for certain audience members (e.g., election officials, donors) whereas lighter colors were used for voters and partners.",
      impact: "→ Impact\n The Democracy Works website and brand relaunch has driven substantial improvements across key digital metrics post-launch. Web traffic grew 72%, lead submissions and Linkedin engagement doubled. In newsletter performance, open rates and click rates both roughly doubled, and new subscriber growth jumped more than 7x.",
      image1: "/images/dw-wtv.webm",
      image2: "/images/dw-05.gif",
      image3: "/images/dwlogos.png",
      image4: "/images/dwcolors.png",
      image5: "/images/dw-04.png",
    },
    { 
      id: 2, 
      title: "TurboVote", 
      x: 25, 
      y: 25, 
      categories: ["Identity"],
      year: "2023",
      role: "Illustrator, Designer",
      deliverables: "illustration, UX/UI",
      image: "/images/tv-03.png",
      tagline: "A homepage illustration suite for personalized voter guidance",
      description: "→ Intro\n [TurboVote](https://turbovote.org/) is a digital platform that offers a personalized voting guidance to show voters what is at stake. Various organizations in private and public sectors partner with TurboVote to engage voters through customized embeds on their sites. I was tasked with creating a new suite of illustrations for the TurboVote homepage  to elevate the voter homepage experience.\n\n Role: Illustrator, Designer\n Product Design by Ryan Pierson",
      research: "→ Challenge\n The challenge was representing a diverse range of people icons that showcased an inclusive range of age, race, and gender. It was also challenging to translate niche voter vocabulary into a visual context relevant to each action. Each suite of people icons also has corresponding object action icons (e.g., “find where to vote” has a person holding a phone with a location icon, and its counterpart object action has just the phone with a location icon).",
      result: "→ Solution\n The solution was leading with flexible expressions, accessories, and a range of skin tones and hair colors to represent a wide range of voter groups. Given that partners had a suite of basic vector icons to begin with, the illustration was built on top of those simple, familiar actions. An accent color was used to emphasize the core action of each terminology. The first suite of icons was completed in 2023, then updated in 2024 to add five more new color offerings. TurboVote was updated with new branding colors in 2026.",
      impact: "→ Impact\n After the initial launch of the new suite of icons, 7.6% partners opted in for a new set of illustrations versus the default vector icons. Partners have the option to choose from 4 choices: default vector, people icons, object icons, or upload their own. The project currently offers 5 colors: red, green, blue, purple, and black to meet partner branding needs better.\n\n Partner Use Cases: [George Washington University](https://gwu.turbovote.org/), [Rutgers University](https://rutgers.turbovote.org/), [Vo+er](https://voter.turbovote.org/)",
      image1: "/images/tv-ill.webm",
      image2: "/images/tv-02.png",
      image3: "/images/tv-icons.png",
      image4: "/images/tv.png",
      image5: "/images/tv-05.png",
    },
    { 
      id: 3, 
      title: "50+1 Strategies", 
      x: 15, 
      y: 40, 
      categories: ["Identity", "Web"],
      year: "2022",
      role: "Lead Designer, Art Director",
      deliverables: "brand identity, web design",
      image: "/images/50p1%20hero.webm",
      tagline: "Rebranding 13 years of grassroots campaign strategy",
      description: "→ Intro\n [50+1 Strategies](https://50p1.com/) was a political consulting firm based in San Francisco that operated for 13 years to build  local campaigns and grassroots movements surrounding progressive advocacy. In their 11th year, I was tasked with their rebrand and art direction of the new website.\n\n Role: Lead Designer, Art Director\n Web Design by Apollo Artistry", 
      research: "→ Challenge\n The challenge was dissecting the firm's title and old a of the numbers (50, 1), signifying a tipping point towards the majority. There was also a need to create a timeless logo symbolic of dynamic, lasting movement for and towards change.",
      result: "→ Solution\n The solution was utilizing the plus sign that served as the joining motif of the two numbers. We arrived at a logo that considers the balance of youthful power as well as dynamism and strength. The layered plus sign offers an open-ended visual interpretation that alludes to windows or doors and portals of change to the other side.",
      impact: "→ Impact\n The new brand identity received overwhelmingly positive feedback from past and present clients with opportunities for new collaborations. The rebrand launch drove website traffic by 147% with a 28% increase in newsletter subscribers.",
      image1: "/images/website.webm",
      image2: "/images/50p1%20billboard.jpg",
      image3: "/images/50p1%20collage.webm", 
      image4: "/images/50p1evolution.webm",
      image5: "/images/50p1-04.jpg",
      image6: "/images/50p1audience.webm",
      image7: "/images/50p1colors.webm",
      image8: "/images/50p1-06.jpg",
    },
    { 
      id: 4, 
      title: "Schema Acquisition", 
      x: 80, 
      y: 35, 
      categories: ["Identity", "Personal"],
      year: "2024 - ongoing",
      role: "Creative director, designer, author",
      deliverables: "brand identity, essays",
      image: "/images/schema-main.gif",
      tagline: "Notes on relation-mapping the self across digital landscapes",
      description: "→ Intro\n [Schema Acquisition](https://schemacquisition.substack.com/) is a personal Substack project exploring relation-mapping the unlikely to engender new abstractions. Garnering schemas on my personal relationship with the digital landscape and studying digital-physical porosity, the project aims to research alternative appropriations of platforms and creative subversion online.", 
      research: "→ Research/Strategy\n Schema acquisition is a cognitive learning theory that I came across during my Neuroscience thesis. It is loosely defined as linking various elements to form a recognizable pattern to engender new abstractions or understanding through a class of structure (think: windows, wheels, seats, etc… = car!). I believe learning about our selfhood and personal world-building is all about big and small experiences of schema acquisition. I wanted the logo to reflect the process of linkage and multiplicity to create new meanings and systems.",
      result: "→ Logo Identity\n The brand identity is built around simple vector points and lines to convey joinment, connection, and gathering. The publication logo is a cursor to signify movement and autonomous direction in the exploration of schema gathering and joinage (whether it be adding or removing to the vector line). Each post is accompanied by \"schema(s)\" or a visual interpretation of the piece as graphs, charts, doodles, etc.", 
      image1: "/images/schemalogo.png",
      image2: "/images/schema-02.png",
      image3: "/images/schemas.jpg",
      image4: "/images/schema-03.png",
    },
    {
      id: 5,
      title: "ASCII Bedroom Memoir",
      x: 55,
      y: 10,
      categories: ["Web", "Personal"],
      externalLink: "https://thehtml.review/04/",
      image: "/images/ascii-main.png"
    },
    { 
      id: 6, 
      title: "Internet Phone Book", 
      x: 90, 
      y: 80, 
      categories: ["Print", "Personal"],
      year: "2025",
      role: "Writer",
      deliverables: "essay",
      image: "/images/ipb.png",
      tagline: "Considering the weird, poetic, soft parts of the internet",
      description: "→ Intro\n The first issue of the [Internet Phone Book](https://internetphonebook.net/), as quoted from the website, is 'an annual publication for exploring the vast poetic web, featuring essays, musings and a directory with the personal websites of hundreds of designers, developers, writers, curators, and educators.' My essay, [A History of My Websites](https://schemacquisition.substack.com/p/9-a-history-of-my-websites), first published on my Substack, is featured on pg. 153 of the publication.\n\n Big thank you to Kristoffer and Elliott for organizing and including me in this issue.", 
      image1: "/images/ipb-02.png",
      image2: "/images/ipb-01.png",
      image3: "/images/ipb-03.png",
      image4: "/images/ipb-05.png",
    },
    // {
    //   id: 7,
    //   title: "WeDream",
    //   x: 43,
    //   y: 20,
    //   categories: ["Web"],
    //   externalLink: "https://www.youtube.com/watch?v=WCObWm1_5cg&feature=youtu.be",
    //   image: "/images/wedream-main.png",
    // },
    // { 
    //   id: 7, 
    //   title: "Alternative Typographic Histories", 
    //   x: 65, 
    //   y: 60, 
    //   categories: ["Print", "Personal"],
    //   year: "2024",
    //   role: "Designer, Researcher",
    //   deliverables: "zine, poster",
    //   image: "/images/alt-type.gif",
    //   description: "→ Intro\n Participating in [School for Poetic Computation (SFPC)'s](https://sfpc.study/) Alternative Typographic Histories class, I conducted an in-depth investigation into jacquard weaving patterns and textile work as a form of alternative language. Jacquard weaving modernized the weaving process and introduced the binary code through its punch card system. Using the punch versus the unpunched system to weave intricate patterns, I wished to study the data of language in a similar format.\n\n Current day, we rely on technologies to archive and utilize systems of language effectively and typing can be seen as a main tool for digital communication. How can type data store meaning beyond what is visible to the eye? What is an alternative interpretation of type language apart from its current usage? I unraveled the encoded keyboard alphabets as ASCII/UTF-8 code of binary strings (e.g. a = 01100001) to write a poem in a punchcard system. This encoded, alternative interpretation of the poem also honors the notion of patternmaking - like its own pixel art, the punchcard poem can be used for knitting, crocheting, and/or weaving to translate into textile art with a hidden message. \n\nThe final project was showcased as a class zine and a poster.",
    //   research: "→ Mentors\n Levi Hammett, Hind Al Saad",
    //   image1: "/images/alt-type-01.png",
    //   image2: "/images/alt-type-02.png"
    // },
    { 
      id: 8, 
      title: "Kernel Issue 5 Zine", 
      x: 40, 
      y: 80, 
      categories: ["Print", "Personal"],
      year: "2025",
      role: "Designer",
      deliverables: "riso zine, essay, illustration",
      image: "/images/kernel-main.jpeg",
      tagline: "",
      description: "→ Intro\n [Kernel Magazine](https://www.kernelmag.io/) is an annual print publication by [Reboot](https://joinreboot.org/), a community reimagining techno-optimism for a better collective future.\n\n For their fifth issue launch, I collaborated with [Connie Liu](https://connie.surf/) to create a special riso zine consisting of a paper ruler, 2 print Reboot features, and a postcard.\n\n The zines were sold alongside the book at the issue launch at Gray Area in San Francisco.",
      image1: "/images/kernel-02.png",
      image2: "/images/kernel-01.png",
      image3: "/images/kernel-04.jpeg",
      image4: "/images/kernel-03.png",
    },
  ];

  // Get navigable projects (those without externalLink)
  const navigableProjects = projects.filter(p => !p.externalLink);

  // ============================================
  // INFO PAGE - Full page with 3 columns
  // ============================================
  if (showInfo) {
    return (
      <div className="h-screen w-screen bg-purple-500 overflow-y-auto">
      {/* Header */}
      <div className="fixed top-0 left-0 right-0 z-50 bg-purple-500 p-6 flex justify-between items-center">
        {/* UPDATED: Name is now clickable to return home */}
        <button
          onClick={() => goHome()}
          className="text-sm text-white hover:text-black"
        >
          Eileen Ahn
        </button>
        <button
          onClick={() => setShowInfo(false)}
          className="text-sm text-white hover:text-black"
        >
          ✕ Close
        </button>
      </div>

        {/* 3 Column Content - EDIT YOUR INFO TEXT HERE */}
        <div className="pt-24 pb-20 px-8 h-[calc(100vh-200px)]">
          <div className="h-full max-w-7xl mx-auto grid grid-cols-3 gap-12">

            {/* Column 1 - EDIT FIRST COLUMN TEXT */}
            <div className="text-sm leading-relaxed text-white">
              <p className="mb-4">
              I am a Korean-American designer, writer, and creative technologist based in San Francisco.
              Activated by inquiries rooted in liberation and autonomy, my art and research practice focus on
              alternative appropriations of digital tools and systems as forms of activism and resistance. I love schemas,
              brutalist frameworks, cats, and crunchy peanut butter. 
              </p>
              <p className="mb-4">
              I currently work as a brand designer at a civic tech nonprofit to make voting more accessible.
              </p>
            </div>

            {/* Column 2 - EDIT SECOND COLUMN TEXT */}
            <div className="text-sm leading-relaxed text-white">
              <p className="mb-4">
                Current Infatuations: <br/>
                &#8594; Song on repeat is ça pik un peu quand même by Miki <br/>
                &#8594; Failing Butter & Crumble's Tuesday box drops <br/>
                &#8594; Experimenting to wear more color instead of all black <br/>
                &#8594; Finished Ted Chiang's Stories of Your Life and Others
              </p>
              <p className="mb-4">
                Selected Writing: <br/> 
                <a 
                  href="https://livingweb.metalabel.com/internetphonebook?variantId=1/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className=" italic hover:text-black transition-colors"
                >
                  &#8594; A History of My Websites 
                </a> on The Internet Phonebook <br/>

                <a 
                  href="https://joinreboot.org/p/my-biological-archive" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className=" italic hover:text-black transition-colors"
                >
                  &#8594; My Biological Archive 
                </a> on Reboot

              </p>
            </div>

            {/* Column 3 - EDIT THIRD COLUMN TEXT */}
            <div className="text-sm leading-relaxed text-white">
              <p className="mb-4">
              ohleenieahn [at] gmail [dot] com
              </p>
              <p className="mb-4">
              <a 
                  href="https://www.instagram.com/leanahnleen/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-black transition-colors"
                >
                  Instagram &#8599;
                </a>
                <br/>
                <a 
                  href="https://www.linkedin.com/in/eileenahn/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-black transition-colors"
                >
                  Linkedin &#8599;
                </a>
                <br/>
                <a 
                  href="https://schemacquisition.substack.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-black transition-colors"
                >
                  Substack &#8599;
                </a>
              </p>
              <p>
              This website was given a <a href= "https://www.websitecarbon.com/website/eileenie-online/" target="_blank" rel="noreferrer" className="hover:text-black transition-colors"> carbon rating &#8599;</a> of A+ where less than 0.01g of CO2 is produced when someone visits the website. It was handmade with love (+ React & Tailwind) and is always in progress…
              </p><br/>

              <p>
              © 2026 Eileen Ahn. All rights reserved.
              </p>
            </div>

          </div>
        </div>
      </div>
    );
  }

  // ============================================
  // HELPER: Render text with markdown-style links
  // ============================================
  const renderTextWithLinks = (text) => {
    if (!text) return null;
    return text.split('\n\n').map((paragraph, index) => (
      <p key={index} className="mb-5">
        {paragraph.split('\n').map((line, i) => {
          const parts = line.split(/(\[.*?\]\(.*?\))/g);
          return (
            <span key={i}>
              {parts.map((part, j) => {
                const linkMatch = part.match(/\[(.*?)\]\((.*?)\)/);
                if (linkMatch) {
                  return (
                    <a
                      key={j}
                      href={linkMatch[2]}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:opacity-50 transition-opacity"
                    >
                      {linkMatch[1]}
                    </a>
                  );
                }
                return <span key={j}>{part}</span>;
              })}
              {i < paragraph.split('\n').length - 1 && <br />}
            </span>
          );
        })}
      </p>
    ));
  };

  // ============================================
  // HELPER: Navigate to prev/next project
  // ============================================
  const navigateProject = (direction) => {
    const currentIndex = navigableProjects.findIndex(p => p.id === selectedProject.id);
    let newIndex;
    if (direction === 'prev') {
      newIndex = currentIndex <= 0 ? navigableProjects.length - 1 : currentIndex - 1;
    } else {
      newIndex = currentIndex >= navigableProjects.length - 1 ? 0 : currentIndex + 1;
    }
    setSelectedProject(navigableProjects[newIndex]);
    window.scrollTo(0, 0);
  };

  // ============================================
  // HELPER: Prev/Next navigation buttons
  // ============================================
  const PrevNextNav = () => {
    const currentIndex = navigableProjects.findIndex(p => p.id === selectedProject.id);
    const prevProject = currentIndex <= 0 ? navigableProjects[navigableProjects.length - 1] : navigableProjects[currentIndex - 1];
    const nextProject = currentIndex >= navigableProjects.length - 1 ? navigableProjects[0] : navigableProjects[currentIndex + 1];
    return (
      <div className="flex justify-between items-center px-6">
        <button
          onClick={() => navigateProject('prev')}
          className="text-sm hover:text-purple-500"
        >
          ← {prevProject.title}
        </button>
        <button
          onClick={() => navigateProject('next')}
          className="text-sm hover:text-purple-500"
        >
          {nextProject.title} →
        </button>
      </div>
    );
  };

  // ============================================
  // HELPER: Render image or video with consistent 9:16 crop
  // ============================================
  const renderMedia = (src, alt = "") => {
    if (!src) return null;
    const mediaClass = "w-full h-full object-cover object-center rounded-lg";
    return (
      <div className="aspect-[16/9] w-full overflow-hidden rounded-lg">
        {src.endsWith('.webm')
          ? <video src={src} autoPlay loop muted playsInline className={mediaClass} />
          : <img src={src} alt={alt} className={mediaClass} />
        }
      </div>
    );
  };

  // ============================================
  // PROJECT DETAIL PAGE
  // ============================================
  if (selectedProject && !showInfo) {
    return (
      <div className="min-h-screen w-screen bg-white overflow-y-auto">
        {/* Header - matches homepage */}
        <div className="fixed top-0 left-0 right-0 z-40 bg-gradient-to-b from-white to-transparent px-6 pt-6 pb-10 flex justify-between items-center">
          <button
            onClick={() => goHome()}
            className="text-sm hover:text-purple-500"
          >
            Eileen Ahn
          </button>
          <button
            onClick={() => { window.history.pushState({ page: 'info' }, ''); setShowInfo(true); }}
            className="text-sm hover:text-purple-500"
          >
            Info
          </button>
        </div>

        {/* Project Header - Centered title and metadata */}
        <div className="pt-20 pb-4 px-6 text-center">
          <h1 className="text-lg font-medium uppercase tracking-wide mb-1">{selectedProject.title}</h1>
          {selectedProject.year && (
            <p className="text-sm text-gray-500 mb-0.5">{selectedProject.year}</p>
          )}
          {selectedProject.role && (
            <p className="text-sm text-gray-500 mb-0.5">Role: {selectedProject.role}</p>
          )}
          {selectedProject.deliverables && (
            <p className="text-sm text-gray-500">Deliverables: {selectedProject.deliverables}</p>
          )}
        </div>

        {/* Top Prev/Next Navigation */}
        <div className="px-2 mb-6">
          <PrevNextNav />
        </div>

        {/* Content Box - Rounded white rectangle */}
        <div className="px-6 pb-10">
          <div className="bg-[#fefff7] border border-black rounded-lg p-8 max-w-8xl mx-auto">
            
            {/* Section 1: Hero Image - Full width */}
            {selectedProject.image && renderMedia(selectedProject.image, selectedProject.title)}

            {/* Section 2: 1/3 text left, 2/3 image right */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
              <div className="text-base leading-relaxed text-black">
                {selectedProject.tagline && (
                  <h2 className="text-4xl font-medium leading-tight mb-4">{selectedProject.tagline}</h2>
                )}
                {renderTextWithLinks(selectedProject.description)}
              </div>
              <div className="md:col-span-2">
                {renderMedia(selectedProject.image1)}
              </div>
            </div>

            {/* Section 3: Full width image */}
            {selectedProject.image2 && (
              <div className="mt-8">{renderMedia(selectedProject.image2)}</div>
            )}

            {/* Section 4: 2/3 image left, 1/3 text right */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
              <div className="md:col-span-2">
                {renderMedia(selectedProject.image3)}
              </div>
              <div className="text-base leading-relaxed text-black">
                {renderTextWithLinks(selectedProject.research)}
                {renderTextWithLinks(selectedProject.result)}
              </div>
            </div>

            {/* Section 5: 1/3 text left, 2/3 image right */}
            {(selectedProject.impact || selectedProject.image4) && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
                <div className="text-base leading-relaxed text-black">
                  {renderTextWithLinks(selectedProject.impact)}
                </div>
                <div className="md:col-span-2">
                  {renderMedia(selectedProject.image4)}
                </div>
              </div>
            )}

            {/* Section 6: Full width image */}
            {selectedProject.image5 && (
              <div className="mt-8">{renderMedia(selectedProject.image5)}</div>
            )}

            {/* Section 7: Two images side by side, 1/2 + 1/2 */}
            {(selectedProject.image6 || selectedProject.image7) && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-8">
                <div>{renderMedia(selectedProject.image6)}</div>
                <div>{renderMedia(selectedProject.image7)}</div>
              </div>
            )}

            {/* Section 8: 2/3 image left, 1/3 text right */}
            {selectedProject.image8 && (
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8">
                <div className="md:col-span-2">
                  {renderMedia(selectedProject.image8)}
                </div>
                <div className="text-base leading-relaxed text-black">
                  {renderTextWithLinks(selectedProject.caption)}
                </div>
              </div>
            )}

          </div>
        </div>

        {/* Bottom Prev/Next Navigation */}
        <div className="px-2 pb-6">
          <PrevNextNav />
        </div>
      </div>
    );
  }

  // ============================================
  // MAIN LANDING PAGE
  // ============================================
  return (
    <div className="relative h-screen w-screen bg-transparent overflow-hidden">
      
      {/* Center Cross Lines - Horizontal and Vertical */}
      <div className="absolute inset-0 pointer-events-none z-10">
        {/* Horizontal line through center */}
        <div className="absolute top-1/2 left-0 right-0 h-px bg-black" />
        {/* Vertical line through center */}
        <div className="absolute left-1/2 top-0 bottom-0 w-px bg-black" />
      </div>
      
      {/* AXIS LABELS - Fixed words at center of each side */}
      {/* Left center - VERTICAL TEXT */}
      <div className="fixed left-6 top-1/2 -translate-y-1/2 z-50 text-xs mix-blend-difference text-gray-400 rotate-180" style={{ writingMode: 'vertical-lr' }}>
        DESIGN
      </div>
      
      {/* Right center - VERTICAL TEXT */}
      <div className="fixed right-6 top-1/2 -translate-y-1/2 z-50 text-xs mix-blend-difference text-gray-400" style={{ writingMode: 'vertical-rl' }}>
        WRITING
      </div>
      
      {/* Top center */}
      <div className="fixed top-6 left-1/2 -translate-x-1/2 z-50 text-xs mix-blend-difference text-gray-400">
        DIGITAL
      </div>
      
      {/* Bottom center */}
      <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 text-xs mix-blend-difference text-gray-400">
        MATERIAL
      </div>

      {/* Top left: Your Name - EDIT YOUR NAME HERE */}
      {/* UPDATED: Now clickable to return to homepage */}
      <button
        onClick={() => goHome()}
        className="fixed top-6 left-6 z-30 text-sm mix-blend-difference text-gray-400 hover:text-purple-500">
        Eileen Ahn
      </button>

      {/* Top right: Info Button */}
      <button
        onClick={() => { window.history.pushState({ page: 'info' }, ''); setShowInfo(true); }}
        className="fixed top-6 right-6 z-30 text-sm mix-blend-difference text-gray-400 hover:text-purple-500"
      >
        Info
      </button>

      {/* Bottom left: Filter Categories - EDIT YOUR CATEGORIES HERE */}
      {/* UPDATED: Now clickable to filter projects */}
      <div className="fixed bottom-6 left-6 z-50 text-xs space-y-1 mix-blend-difference">
        <div
          className={`cursor-pointer transition-colors ${
            activeFilter === "All" ? "text-purple-500" : "text-gray-400 hover:text-purple-500"
          }`}
          onClick={() => setActiveFilter("All")}
        >
          All
        </div>
        <div
          className={`cursor-pointer transition-colors ${
            activeFilter === "Identity" ? "text-purple-500" : "text-gray-400 hover:text-purple-500"
          }`}
          onClick={() => setActiveFilter(activeFilter === "Identity" ? "All" : "Identity")}
        >
          Brand Identity
        </div>
        <div
          className={`cursor-pointer transition-colors ${
            activeFilter === "Web" ? "text-purple-500" : "text-gray-400 hover:text-purple-500"
          }`}
          onClick={() => setActiveFilter(activeFilter === "Web" ? "All" : "Web")}
        >
          Web
        </div>
        <div
          className={`cursor-pointer transition-colors ${
            activeFilter === "Print" ? "text-purple-500" : "text-gray-400 hover:text-purple-500"
          }`}
          onClick={() => setActiveFilter(activeFilter === "Print" ? "All" : "Print")}
        >
          Print
        </div>
        <div
          className={`cursor-pointer transition-colors ${
            activeFilter === "Personal" ? "text-purple-500" : "text-gray-400 hover:text-purple-500"
          }`}
          onClick={() => setActiveFilter(activeFilter === "Personal" ? "All" : "Personal")}
        >
          Personal
        </div>
      </div>


      {/* Project Dots on X,Y Coordinates */}
       <div className="absolute inset-0">
        {projects.map((project) => {
          // Check if this project matches the active filter
          const isVisible = activeFilter === "All" || project.categories.includes(activeFilter);
          
          return (
            <button
              key={project.id}
              className="absolute z-30"
              style={{
                left: `${project.x}%`,
                top: `${project.y}%`,
                transform: 'translate(-50%, -50%)'
              }}
              onMouseEnter={() => setHoveredProject(project)}
              onMouseLeave={() => setHoveredProject(null)}
              onClick={() => {
                // If project has externalLink, open in new tab
                if (project.externalLink) {
                  window.open(project.externalLink, '_blank', 'noopener,noreferrer');
                } else {
                  window.history.pushState({ page: 'project', id: project.id }, '');
                  setSelectedProject(project);
                }
              }}
            >

              <div
                className={`w-4 h-4 rounded-full transition-all ${
                  hoveredProject?.id === project.id ? 'scale-150' : ''
                } ${
                  isVisible ? 'bg-black' : 'bg-gray-300'
                }`}
              />
            </button>
          );
        })}
      </div>

      {/* Center Hover Image Preview */}
      {hoveredProject && (
        <div className="fixed inset-0 -z-10 pointer-events-none">
          {hoveredProject.image.endsWith('.webm')
            ? <video src={hoveredProject.image} autoPlay loop muted playsInline className="w-full h-full object-cover" />
            : <img src={hoveredProject.image} alt={hoveredProject.title} className="w-full h-full object-cover" />
          }
        </div>
        // <div
        //   className="fixed z-40 pointer-events-none"
        //   style={{
        //     left: '50%',
        //     top: '50%',
        //     transform: 'translate(-50%, -50%)'
        //   }}
        // >
        //   <img
        //     src={hoveredProject.image}
        //     alt={hoveredProject.title}
        //     className="w-96 h-96 object-cover"
        //   />
        // </div>
      )}
    </div>
  );
};

export default Portfolio;